import React, { useContext, useState, useRef, useEffect } from 'react';
import { Environment } from 'src/Environment';
import { Redirect } from 'react-router-dom';

import { MerchantProfileContext } from 'src/context/merchant-profile-context';
import cashAdvanceImage from 'src/assets/images/cash-advance-congrats.png';
import { Card } from 'src/components';

import { paymentsDashboardRoute } from 'src/routing/routes';
import { OfferContext } from 'src/context/offer-context';
import { formatCurrencyAmountSimple } from 'src/helpers/formatting';

export default function BusinessCashAdvanceApproved() {
  const { merchant } = useContext(MerchantProfileContext);
  const { chosenOffer } = useContext(OfferContext);
  const [redirect] = useState();
  const topOfPage = useRef('top');

  useEffect(() => {
    if (topOfPage.current) {
      topOfPage.current.scrollIntoView(false);
    }
  }, []);

  // TODO: BCA Flag to be removed
  if (Environment.current?.disabledFeatures?.bca) {
    return <Redirect push to={paymentsDashboardRoute} />;
  }
  if (redirect) {
    return <Redirect push to={redirect} />;
  }

  return (
    <div>
      <div className="box">
        <div className="columns">
          <div className="column is-7">
            <h3
              className="box-sub-title is-size-3 has-text-weight-bold"
              automationid="Business_Cash_Advance_Approved_H3_Heading"
              ref={topOfPage}
            >
              Congratulations {merchant?.companyName}
            </h3>
            <hr />
            <h2
              className="box-title is-size-4 has-margin-bottom-3"
              automationid="BCA_Header_Approved_Title"
            >
              Your R{formatCurrencyAmountSimple(chosenOffer?.Amount)} Business Cash Advance will be
              in your merchant account shortly.
            </h2>
            <p>Please check your email with the confirmation and contract details.</p>
          </div>
          <div className="column is-5">
            <img src={cashAdvanceImage} alt="Cash Advance Approved" />
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column">
          <Card cardTitle="Date of cash injection">
            <p>Your advance should be in your account within</p>
            <h2
              className="box-title is-size-4 has-text-weight-bold"
              automationid="Business_Cash_Advance_Approved_H2_Date_Of_Cash_Injection"
            >
              48 hours
            </h2>
          </Card>
        </div>
        <div className="column">
          <Card cardTitle="First repayment">
            <p>The first repayment will be deducted from your Vodacom Payment Services Account</p>
            <h2
              className="box-title is-size-4 has-text-weight-bold"
              automationid="Business_Cash_Advance_Approved_H2_Date_Of_First_Repayment"
            >
              72 hours
            </h2>
            <p>after you receive the cash advance.</p>
          </Card>
        </div>
        <div className="column">
          <Card cardTitle="Contact us">
            <p>Have a query? Get in touch</p>
            <h2 className="box-title is-size-4 has-text-weight-bold">082 17855</h2>
          </Card>
        </div>
      </div>
    </div>
  );
}
